import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpGenericService } from '@app/@core/services';
import { environment } from '@environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from './user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends HttpGenericService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(httpClient: HttpClient) {
    super(httpClient, environment.apiUrl, 'auth');
    const current: any = sessionStorage.getItem('currentUser');
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(current));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(usuario: string, password: string) {
    return super
      .post({ usuario, password }, { urlPostfix: 'Authenticate' })
      .pipe(
        map((user) => {
          // Store user details and jwt token in local storage
          // to keep user logged in between page refreshes
          sessionStorage.setItem('currentUser', JSON.stringify(user));
          this.currentUserSubject.next(user as User);
          return user;
        })
      );
  }

  register(user: User) {
    return super.post(user, { urlPostfix: 'register' });
  }

  // beginPasswordReset(email: string) {
  //   return super.post({ email }, 'begin-password-reset');
  // }

  resetPassword(usuario: string, password: string, token: string) {
    return super.post(
      { usuario, password, token },
      { urlPostfix: 'reset-password' }
    );
  }

  logout() {
    // Remove user from local storage to log user out
    sessionStorage.removeItem('currentUser');
    const item: any = null;
    this.currentUserSubject.next(item);
  }
}
